import { render, staticRenderFns } from "./BrokerTableRow.vue?vue&type=template&id=3b87a374&"
import script from "./BrokerTableRow.vue?vue&type=script&lang=ts&"
export * from "./BrokerTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports